var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0607 20.5607C24.4749 21.1464 23.5251 21.1464 22.9393 20.5607L15 12.6213L7.06066 20.5607C6.47487 21.1464 5.52513 21.1464 4.93934 20.5607C4.35355 19.9749 4.35355 19.0251 4.93934 18.4393L13.9393 9.43934C14.5251 8.85355 15.4749 8.85355 16.0607 9.43934L25.0607 18.4393C25.6464 19.0251 25.6464 19.9749 25.0607 20.5607Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.0cd131dafdd18512c6584a974050d51d.svg";
export { ForwardRef as ReactComponent };